export default __webpack_public_path__ + "static/banner-what-to-look-out-for-when-buying-a-car-288464793c3cc855f06d7f66c68a89b8.jpg";